module.exports = "/fonts/Roboto-Regular.ttf?4312f1fbdcf4d54af4506dabdce08010";